import React from 'react';
import { ItineraryItem } from '../../types/Quotation';

interface ActivityTableProps {
  itinerary: ItineraryItem[];
  onRemove?: (dayIndex: number, activityIndex: number) => void;
  hideActions?: boolean;
}

const ActivityTable: React.FC<ActivityTableProps> = ({ itinerary, onRemove, hideActions = false }) => {
  const rows = itinerary.flatMap((day, dayIndex) =>
    (day.activities || []).map((a, activityIndex) => ({ ...a, day: day.day, dayIndex, activityIndex }))
  );

  if (!rows.length) return null;

  const currencySymbol = (c?: string) => (c === 'USD' ? '$' : c === 'EUR' ? '€' : '₹');

  return (
    <table className="flight-table">
      <thead>
        <tr>
          <th>Day</th>
          <th>Name</th>
          <th>Start Time</th>
          <th>Duration</th>
          <th>Price</th>
          {!hideActions && <th>Action</th>}
        </tr>
      </thead>
      <tbody>
        {rows.map((a, idx) => (
          <tr key={idx}>
            <td>{a.day}</td>
            <td>{a.name}</td>
            <td>{a.start_time || '-'}</td>
            <td>{a.duration_minutes ? `${Math.floor(a.duration_minutes / 60)}h ${a.duration_minutes % 60}m` : '-'}</td>
            <td>{currencySymbol(a.currency)}{a.from_price_paise ? Math.round(a.from_price_paise / 100).toLocaleString('en-IN') : 'N/A'}</td>
            {!hideActions && onRemove && (
              <td>
                <button onClick={() => onRemove(a.dayIndex, a.activityIndex)}>×</button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ActivityTable;

